<template>
  <section>
    <section v-for="(slice, index) in slices" :key="'slice-' + index">
      <!-- FAQ template -->
      <template v-if="slice.slice_type === 'faq'">
        <FAQ :slice="slice"></FAQ>
      </template>

      <!-- Image Columns template -->
      <template v-else-if="slice.slice_type === 'image_list'">
        <ImageList :slice="slice"></ImageList>
      </template>

      <!-- PODs template -->
      <template v-else-if="slice.slice_type === 'pod'">
        <PODs :slice="slice"></PODs>
      </template>

      <!-- Text Columns template -->
      <template v-else-if="slice.slice_type === 'text_columns'">
        <TextColumns :slice="slice"></TextColumns>
      </template>

      <!-- Left Image template -->
      <template v-else-if="slice.slice_type === 'left_image'">
        <LeftImage :slice="slice"></LeftImage>
      </template>

      <!-- Image Slice -->
      <template v-else-if="slice.slice_type === 'image'">
        <ImageSlice :slice="slice" />
      </template>
    </section>
  </section>
</template>

<script>
// Imports for all slices
const FAQ = () => import('@/components/Prismic/CustomHtml/Slices/FAQ.vue');
const ImageList = () => import('@/components/Prismic/CustomHtml/Slices/ImageList.vue');
const PODs = () => import('@/components/Prismic/CustomHtml/Slices/PODs.vue');
const TextColumns = () => import('@/components/Prismic/CustomHtml/Slices/TextColumns.vue');
const LeftImage = () => import('@/components/Prismic/CustomHtml/Slices/LeftImage.vue');
const ImageSlice = () => import('@/components/Prismic/CommonSlices/Image.vue');

export default {
  name: 'SlicesBlock',
  components: {
    FAQ,
    ImageList,
    PODs,
    TextColumns,
    LeftImage,
    ImageSlice
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['slices']
};
</script>
